<div class="content">
    <h2>Missing traduction for the file '{{currentLanguage}}.json'</h2>
  
    <div>How it works ?</div>
    <ul>
      <li>Select language you want to translate : <app-select-language></app-select-language></li>
      <li>Fill gray field with translation</li>
      <li>
        Click on <button (click)="prepareFileMissingTrad()">download translation</button> to get the translation file
      </li>
      <li>
        Send to translation file to <a href="mailto:support@ariadis.fr">support@ariadis.fr</a>
      </li>
  
    </ul>
  
    <div>If a text is not display bellow, you can click here : <button (click)="addMissingTrad()">Add missing translation</button></div>
  
    <h3 *ngIf="arrayMissingTranslation.length == 0">No missing translation found</h3>
  
    <table>
      <tr>
        <th style="width: 50px;"></th>
        <th>English text</th>
        <th>Translated text</th>
      </tr>
      <tr *ngFor="let missingTranslation of arrayMissingTranslation; let i=index">
        <td>
          {{i+1}}
        </td>
        <td>
          <ng-container *ngIf="missingTranslation.AddedManualy; else elseTemplate">
            <input type="text" placeholder="Missing english text" [(ngModel)]="missingTranslation.EnglishName">
          </ng-container>
          <ng-template #elseTemplate>
            {{missingTranslation.EnglishName}}
          </ng-template>
        </td>
        <td>
          <input type="text" placeholder="Missing translated text" [(ngModel)]="missingTranslation.TranslatedValue">
        </td>
      </tr>
    </table>
  
  </div>